import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import "./FileReorderDisplay.css";

interface IFileReorderDisplayProps {
    name: string;
    date: string;
    type: string;
    onClose: () => void;
    onRowClick: () => void;
    isSelected: boolean;
}

class FileReorderDisplay extends BaseReactComponent<IFileReorderDisplayProps> {
    public render(): JSX.Element {
        const selected = this.props.isSelected ? "selected" : "";
        return (
            <div className={`file-reorder-display-container ${selected}`}>
                <div className="file-reorder-info-container" onClick={this.props.onRowClick}>
                    <div className="file-reorder-name">{this.props.name}</div>
                    <div>{this.props.date}</div>
                    <div>{this.props.type}</div>
                </div>
                <div className="file-reorder-close-container">
                    <div className="file-reorder-close fa fa-times fa-lg" onClick={this.props.onClose} />
                </div>
            </div>
        );
    }
}

export { FileReorderDisplay };
